import { FC, useEffect, useMemo, useState } from "react"

import ListSkeleton from "../../../../../skeletons/normal-list"
import NoData from "../../../../../no-data"
import Table from "../../../../../table"
import TableFooter from "../../../../../table/footer"
import { useFetchUnsubscribedStatsQuery } from "../../../../../../../redux/queries"
import { useTableFooterData } from "../../../../../../hooks"
import { getUnsubscribedStatsColumns } from "../columns"
import { BBColumnDef, UnsubscribedStats } from "../../../../../../../types"
import { EmailStatsTabs } from "../.."

interface UnsubscribedTableProps {
  range: number
  orgId: string | undefined
  loid: string | undefined
}

const UnsubscribedTable: FC<UnsubscribedTableProps> = ({
  range,
  orgId,
  loid
}) => {
  const [isFetching, setIsFetching] = useState<boolean>(true)
  const unsubscribedColumns: BBColumnDef<UnsubscribedStats>[] =
    getUnsubscribedStatsColumns()
  const { data: unsubscribedData, isFetching: isFetchingUnsubscribed } =
    useFetchUnsubscribedStatsQuery(
      {
        range,
        org_id: orgId,
        loid
      },
      { refetchOnMountOrArgChange: true }
    )
  const containsData = useMemo(
    () => unsubscribedData && unsubscribedData?.length > 0,
    [unsubscribedData]
  )
  const footerData = useTableFooterData(
    unsubscribedData,
    isFetching,
    containsData,
    EmailStatsTabs.UNSUBSCRIBED
  )

  useEffect(() => {
    setIsFetching(isFetchingUnsubscribed)
  }, [isFetchingUnsubscribed])

  return (
    <div className="flex flex-col">
      <Table
        isLoading={isFetching}
        data={unsubscribedData ?? []}
        columns={unsubscribedColumns}
        viewType="table"
        tableContainerClassName="h-[380px]"
        tableClassName="md:table-fixed"
        tableHeaderClassName="px-3 pt-0 pb-6 text-left text-sm font-medium uppercase"
        extraHeaderElementClassName="w-full md:w-auto md:ml-auto"
        loaderSkeleton={
          <ListSkeleton noOfRows={4} containerClassName="px-6 pt-4 pb-8" />
        }
        extraElementAfterTable={
          footerData?.length > 0 ? (
            <TableFooter
              rows={footerData}
              containerClassName={
                unsubscribedData && unsubscribedData.length > 5
                  ? "pl-6 pr-10"
                  : "px-6"
              }
            />
          ) : null
        }
        noDataElement={
          <td colSpan={4}>
            <div className="flex w-full h-[210px]">
              <NoData />
            </div>
          </td>
        }
        searchBarVisible={false}
      />
    </div>
  )
}

export default UnsubscribedTable
